import { GiBarracksTent } from "react-icons/gi";
import { TbTruckDelivery } from "react-icons/tb";
import { MdOutlineChair } from "react-icons/md";

const data = [
  {
    icon: <GiBarracksTent />,
    heading:
      "Namioty o najwyższej jakości spośród wszystkich dostępnych na rynku",
    detail:
      "Namioty o najwyższej jakości są wyborem nie tylko dla profesjonalnych imprez i wydarzeń, ale także dla niezapomnianych komunii i wesel. Zapewniają one imponujący wygląd, ale również stwarzają magiczną atmosferę, idealną dla tych wyjątkowych uroczystości. Dzięki solidnym konstrukcjom i starannemu wykonaniu, namioty eventowe gwarantują niezawodność nawet podczas zmiennej pogody, zapewniając bezpieczne przestrzenie dla gości.",
  },
  {
    icon: <TbTruckDelivery />,
    heading:
      "Punktualna dostawa i profesjonalny montaż - zapewniamy niezawodność!",
    detail:
      "Gwarantujemy punktualną dostawę i profesjonalny montaż, aby spełnić oczekiwania naszych klientów. Działamy z precyzją i dokładnością, aby zapewnić, że każde zamówienie jest dostarczane na czas i instalowane z najwyższym poziomem fachowości. Nasze zobowiązanie do niezawodności i satysfakcji klienta sprawia, że możesz mieć pewność, że dostawa i montaż zostaną przeprowadzone zgodnie z ustalonym harmonogramem i najwyższymi standardami jakości.",
  },
  {
    icon: <MdOutlineChair />,
    heading: "Bogaty wybór wyposażenia dodatkowego",
    detail:
      "Oferujemy bogaty wybór solidnych i funkcjonalnych dodatków do namiotów, takich jak różnego rodzaju stoły, wygodne krzesła, nowoczesne oświetlenie LED, trwałe podłogi, eleganckie lustra i praktyczne wieszaki oraz możliwość pełnego dopasowania ich do indywidualnych potrzeb każdej uroczystości, aby stworzyć komfortowe wnętrza, w których mile spędzą czas ich goście.",
  },
];

export default data;
